// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-branch-form {
  width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-branch-form .branch-form-user-form {
  width: 100%;
  max-width: 500px;
  background: #fff;
  transition: all 0.3s ease-in-out;
}
.add-branch-form .branch-form-user-form h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #1e1e1e;
  font-size: 1.3rem;
}
.add-branch-form .branch-form-user-form label {
  display: block;
  margin-bottom: 1.5rem;
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}
.add-branch-form .branch-form-user-form label input {
  width: 100%;
  margin-top: 0.4rem;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border 0.2s ease;
}
.add-branch-form .branch-form-user-form label input:focus {
  border-color: var(--primary-color);
  outline: none;
}
.add-branch-form .branch-form-user-form label .error {
  color: #e74c3c;
  font-size: 0.85rem;
  margin-top: 0.4rem;
  display: block;
}
.add-branch-form .branch-form-user-form .branch-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.add-branch-form .branch-form-user-form .branch-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.add-branch-form .branch-form-user-form .branch-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-branch-form .branch-form-user-form .button-group {
  display: flex;
  justify-content: end;
  gap: 0.5rem;
  margin-top: 1rem;
}
.add-branch-form .branch-form-user-form .button-group button {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.add-branch-form .branch-form-user-form .button-group button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.add-branch-form .branch-form-user-form .button-group .save-btn {
  background: var(--primary-color);
  color: white;
}
.add-branch-form .branch-form-user-form .button-group .save-btn:hover {
  background: var(--primary-color);
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn {
  background: #6b7280;
  color: white;
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn:hover {
  background: #4b5563;
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn:active {
  background: #374151;
}
@media (max-width: 768px) {
  .add-branch-form .branch-form-user-form {
    padding: 1.5rem;
  }
  .add-branch-form .branch-form-user-form h2 {
    font-size: 1.5rem;
  }
  .add-branch-form .branch-form-user-form label {
    font-size: 0.95rem;
  }
  .add-branch-form .branch-form-user-form label input {
    font-size: 0.95rem;
  }
  .add-branch-form .branch-form-user-form label .error {
    font-size: 0.8rem;
  }
  .add-branch-form .branch-form-user-form .button-group button {
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .add-branch-form .branch-form-user-form {
    padding: 1rem;
  }
  .add-branch-form .branch-form-user-form h2 {
    font-size: 1.3rem;
  }
  .add-branch-form .branch-form-user-form label {
    font-size: 0.9rem;
  }
  .add-branch-form .branch-form-user-form label input {
    font-size: 0.9rem;
    padding: 0.65rem;
  }
  .add-branch-form .branch-form-user-form label .error {
    font-size: 0.75rem;
  }
  .add-branch-form .branch-form-user-form .button-group {
    flex-direction: column;
  }
  .add-branch-form .branch-form-user-form .button-group button {
    width: 100%;
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/BranchForm/BranchForm.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;EAGA,gBAAA;EACA,gCAAA;AADJ;AAGI;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AADN;AAII;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAFN;AAIM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;AAFR;AAIQ;EACE,kCAAA;EACA,aAAA;AAFV;AAMM;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAJR;AAOI;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAOI;EACE,yBAAA;EACA,cAAA;AALN;AAQI;EACE,aAAA;EACA,6CAAA;AANN;AAUI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AARN;AAUM;EAQE,iBAAA;EACJ,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAfJ;AAiBQ;EACE,YAAA;EACA,mBAAA;AAfV;AAmBM;EAYE,gCAAA;EACJ,YAAA;AA5BJ;AA8BI;EACE,gCAAA;AA5BN;AAgCM;EAoBA,mBAAA;EACF,YAAA;AAjDJ;AAmDI;EACE,mBAAA;AAjDN;AAoDI;EACE,mBAAA;AAlDN;AAwDI;EA7JF;IA8JI,eAAA;EArDJ;EAuDI;IACE,iBAAA;EArDN;EAwDI;IACE,kBAAA;EAtDN;EAwDM;IACE,kBAAA;EAtDR;EAyDM;IACE,iBAAA;EAvDR;EA4DM;IACE,kBAAA;EA1DR;AACF;AA+DI;EAxLF;IAyLI,aAAA;EA5DJ;EA8DI;IACE,iBAAA;EA5DN;EA+DI;IACE,iBAAA;EA7DN;EA+DM;IACE,iBAAA;IACA,gBAAA;EA7DR;EAgEM;IACE,kBAAA;EA9DR;EAkEI;IACE,sBAAA;EAhEN;EAkEM;IACE,WAAA;IACA,kBAAA;EAhER;AACF","sourcesContent":[".add-branch-form {\n  width: 450px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .branch-form-user-form {\n    width: 100%;\n    max-width: 500px;\n    // margin: 2rem auto;\n    //padding: 1rem;\n    background: #fff;\n    transition: all 0.3s ease-in-out;\n\n    h2 {\n      text-align: center;\n      margin-bottom: 1.5rem;\n      color: #1e1e1e;\n      font-size: 1.3rem;\n    }\n\n    label {\n      display: block;\n      margin-bottom: 1.5rem;\n      font-weight: 600;\n      color: #333;\n      font-size: 1rem;\n\n      input {\n        width: 100%;\n        margin-top: 0.4rem;\n        padding: 0.75rem;\n        border-radius: 8px;\n        border: 1px solid #ccc;\n        font-size: 1rem;\n        box-sizing: border-box;\n        transition: border 0.2s ease;\n\n        &:focus {\n          border-color: var(--primary-color);\n          outline: none;\n        }\n      }\n\n      .error {\n        color: #e74c3c;\n        font-size: 0.85rem;\n        margin-top: 0.4rem;\n        display: block;\n      }\n    }\n    .branch-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n\n    .button-group {\n      display: flex;\n      justify-content: end;\n      gap: 0.5rem;\n      margin-top: 1rem;\n\n      button {\n        // padding: 8px 18px;\n        // font-size: 1rem;\n        // border-radius: 8px;\n        // border: 1px solid #ddd;\n        // cursor: pointer;\n        // transition: all 0.3s ease;\n\n        padding: 8px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 80px;\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n\n      .save-btn {\n        // background: var(--primary-color);\n        // color: white;\n\n        // &:hover:not(:disabled) {\n        //   background: var(--primary-color);\n        // }\n\n        // &:disabled {\n        //   background: #9ca3af;\n        //   color: #6b7280;\n        // }\n        background:var(--primary-color);\n    color: white;\n\n    &:hover {\n      background: var(--primary-color);\n    }\n      }\n\n      .cancel-btn {\n        //background: #666;\n        //color: white;\n\n        //background:var(--grey-shade-two);\n        //background: white;\n        //color: #666;\n\n        // &:hover:not(:disabled) {\n        //   background: #c82333;\n        // }\n\n      //   &:hover {\n      //   background-color: #f8f9fa;\n      // }\n\n      //   &:disabled {\n      //     background: #d1d5db;\n      //     color: #9ca3af;\n      //   }\n      background: #6b7280;\n    color: white;\n\n    &:hover {\n      background: #4b5563;\n    }\n\n    &:active {\n      background: #374151;\n    }\n      }\n    }\n\n    // Tablet responsiveness\n    @media (max-width: 768px) {\n      padding: 1.5rem;\n\n      h2 {\n        font-size: 1.5rem;\n      }\n\n      label {\n        font-size: 0.95rem;\n\n        input {\n          font-size: 0.95rem;\n        }\n\n        .error {\n          font-size: 0.8rem;\n        }\n      }\n\n      .button-group {\n        button {\n          font-size: 0.95rem;\n        }\n      }\n    }\n\n    // Mobile responsiveness\n    @media (max-width: 480px) {\n      padding: 1rem;\n\n      h2 {\n        font-size: 1.3rem;\n      }\n\n      label {\n        font-size: 0.9rem;\n\n        input {\n          font-size: 0.9rem;\n          padding: 0.65rem;\n        }\n\n        .error {\n          font-size: 0.75rem;\n        }\n      }\n\n      .button-group {\n        flex-direction: column;\n\n        button {\n          width: 100%;\n          font-size: 0.95rem;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
